import { render, staticRenderFns } from "./ImportCustomerModal.vue?vue&type=template&id=5f8bd8bc"
import script from "./ImportCustomerModal.vue?vue&type=script&lang=js"
export * from "./ImportCustomerModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports